import React from "react";
import { Tag } from "../../../tag/tag";
import { LoyaltyCarousel } from "../carousel/LoyaltyCarousel";
import { Body, ClientHeader, ClientInfo } from "./LoyaltyBody.styled";


export const LoyaltyBody = ({ clientName, loyalty }) => {
    
    const { id, status, cards } = loyalty;

    return (
        <Body>
            <ClientHeader>
                <ClientInfo>
                    <p> {clientName} </p>
                    <span> Id fidelidade: {id} </span>
                </ClientInfo>
                <Tag type={status ? 'positive' : 'negative'}>
                    {status ? 'Ativo' : 'Inativo'}
                </Tag>
            </ClientHeader>
            <LoyaltyCarousel cardList={cards} />
        </Body>
    )
}
